import React from 'react';
import Card from './containers/Card';
import './Benefits.scss';

function Benefits(props) {
  return (
    <section className="Benefits" id="benefits">
      <div className="benefits-wrapper">
        <p className="benefits-title">Beneficios de la Plataforma</p>
        <p className="benefits-subtitle">
          Descubre cómo funciona Contacta Abogado® y todos los beneficios que
          tenemos para ti
        </p>
        <div className="CardsBenefits">
          <div className="card-container">
            <Card
              image="./img/Landing/benefits/uno.svg"
              text="Visible para un gran número de clientes potenciales"
              styleCard="margin-card-1"
            />
            <Card
              image="./img/Landing/benefits/dos.svg"
              text="Interactúa fácilmente desde tu celular o computadora"
              styleCard="margin-card-2"
            />
            <Card
              image="./img/Landing/benefits/tres.svg"
              text="Tendrás un análisis de tu rendimiento en el sitio"
              styleCard="margin-card-3"
            />
            <Card
              image="./img/Landing/benefits/cuatro.svg"
              text="Recibe notificaciones en tiempo real dentro de la plataforma"
              styleCard="margin-card-4"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Benefits;
